import { Component, Input, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { CampaignLocationFilter, LocationFilterByOrganizationId, LocationFilterByOrganizationTag, TagItem } from 'src/app/api/api-campaigns.service.generated';
import { AdvertiserOrganizationsSearchComponent } from '../../../advertiser-organizations-search/advertiser-organizations-search.component';
import { OrganizationTagSelectComponent } from '../organization-tag-select/organization-tag-select.component';
import { FilterByOrganizationIdComponent } from 'src/app/common/components/filter-by-organization-id/filter-by-organization-id.component';
import { FilterByOrganizationTagComponent } from 'src/app/common/components/filter-by-organization-tag/filter-by-organization-tag.component';
import { ButtonComponent } from 'wecheer-common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';

export enum LocFilterType {
  ByOrganizationId = 'LocationFilterByOrganizationId',
  ByOrganizationTag = 'LocationFilterByOrganizationTag',
}

@Component({
  selector: 'app-campaign-location-filters',
  templateUrl: './campaign-location-filters.component.html',
  styleUrls: ['./campaign-location-filters.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    MatGridListModule,
    FilterByOrganizationIdComponent,
    FilterByOrganizationTagComponent,
    ButtonComponent
  ]
})
export class CampaignLocationFiltersComponent {
  private dialog = inject(MatDialog);

  @Input() campaignId: string;
  @Input() originalCampaignId: string;

  model: CampaignLocationFilter;
  LocFilterType = LocFilterType;

  isLoading: boolean;

  currentView = 0;

  public setFormValue(model: CampaignLocationFilter) {
    this.model = model || new CampaignLocationFilter({ campaignId: this.campaignId, filters: [] });
  }

  public getFormValue() {
    return this.model;
  }

  async onAddFilter_ByOrganizationId() {
    const org = await AdvertiserOrganizationsSearchComponent.open(this.dialog, undefined);
    if (!org) return;

    let filter = this.model.filters && this.model.filters.find(f => f.type === LocFilterType.ByOrganizationId) as LocationFilterByOrganizationId;
    if (!filter) {
      filter = new LocationFilterByOrganizationId({ type: LocFilterType.ByOrganizationId, organizationIds: [org.id.toString()] });
      this.model.filters.push(filter);
      return;
    }

    if (!filter.organizationIds)
      filter.organizationIds = [];

    filter.organizationIds.push(org.id.toString());
    this.rebind();
  }

  async onAddFilter_ByOrganizationTag() {
    const kvTags = await OrganizationTagSelectComponent.open(this.dialog);
    if (!kvTags) return;

    const tags = kvTags.map(kv => new TagItem({ tag: kv.tag, value: kv.value }));
    const filter = new LocationFilterByOrganizationTag({ type: LocFilterType.ByOrganizationTag, tags: tags });
    this.model.filters.push(filter);
  }

  onDeleteFilter(filter) {
    const ix = this.model.filters.indexOf(filter);
    this.model.filters.splice(ix, 1);
  }

  onDeleteOrganisationId(orgId: string) {
    const filter = this.model.filters.find(f => f.type === LocFilterType.ByOrganizationId);
    const filterById = filter as LocationFilterByOrganizationId;
    const ix = filterById.organizationIds.indexOf(orgId);
    filterById.organizationIds.splice(ix, 1);

    if (filterById.organizationIds.length === 0)
      this.onDeleteFilter(filter);

    this.rebind();
  }

  rebind() {
    for (let i = 0; i < this.model.filters.length; i++) {
      this.model.filters[i] = { ...this.model.filters[i] };
    }
  }

  getTags(filter: LocationFilterByOrganizationTag) {
    return filter.tags;
  }
}
